import React from 'react';
import './App.css';
import { AuthProvider } from './reusable-components/AuthContext';
import { RouterComponent } from './reusable-components/RouterComponent';
import { CurrentPageProvider } from './reusable-components/CurrentPageContext';
import { ErrorBoundary } from './reusable-components/ErrorBoundary';
import { createErrorHandler } from './utils/error-reporting';
import { CacheStatus } from './reusable-components/CacheStatus';

/**
 * Error handler for the main Error Boundary.
 * Uses the centralized error reporting utility.
 */
const handleGlobalError = createErrorHandler({
  level: 'global',
  component: 'App',
});

const App = () => {
  return (
    <CacheStatus>
      <ErrorBoundary onError={handleGlobalError}>
        <AuthProvider>
          <CurrentPageProvider>
            <div className="p-4">
              <RouterComponent />
            </div>
          </CurrentPageProvider>
        </AuthProvider>
      </ErrorBoundary>
    </CacheStatus>
  );
};

export default App;
